import { useEffect, useState } from "react";
import { useNavigationContext } from "../../Context/NavigationContext";
import { TypeAnimation } from 'react-type-animation';
import { useGlobalContext } from "../../Context/GlobalContext";

const SplashView = () => {
    const { setEntering, changeLandingView, navigateTo } = useNavigationContext();
    const { dbManager, deviceManager } = useGlobalContext();
    const [videoFinished, setVideoFinished] = useState<boolean>(false);

    useEffect(() => {
        if(sessionStorage.getItem("inSession")) {
            setEntering(true);
        } else {
            sessionStorage.setItem("inSession", "true");  
            setTimeout(() => {
                setVideoFinished(true);
            }, 6000);

            setTimeout(() => {
                changeLandingView('start');
                setEntering(true);
            }, 9000);
        }
    }, [deviceManager, setEntering, changeLandingView, navigateTo]);

    return (
        <div className="splash crt">
            { videoFinished && <div className="type-wrapper">
                <TypeAnimation
                    sequence={[
                        'Welcome',
                        300,
                        `Welcome${dbManager.user ? ', ' + dbManager.user.first_name : ''}...`
                    ]}
                    wrapper="span"
                    speed={150 as any}
                    style={{ fontSize: '1vw', position: 'absolute', top: '20%', left: '20%', opacity: 0.8 }}
                /> 
            </div> }
            { !videoFinished && 
            <video 
                width="100%" 
                autoPlay 
                muted 
            >
                <source src="/assets/Splash.mp4" type="video/mp4"/>
            </video> }
        </div>
    );
};

export default SplashView;
